import { useEffect, useState } from "react";
import axios from "axios";

import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import { GroupDistribution, HistoryArea, ProfileArea } from "../section/about";

const MOCK_GROUP_DISTRIBUTION_DATA = {
  title: "集團分布",
  subTitle: "Group Distribution",
  coverImage:
    "http://cdn.asiamc.com.tw/5cJrdTjjQsD58xDjtzn88z.png",
  companyList: [
    {
      id: 1001,
      title: "金融保險",
      icon: "http://cdn.asiamc.com.tw/W2vZdNAfcEtradeXVkZJRv.jpg",
      linkListHtml: `
        <a target="_blank" rel="noreferrer" href="https://life.titanstonegroup.com/tc.php">巨石人壽保險、易機保</a><br/>
        <a target="_blank" rel="noreferrer" href="https://cambodiasecurities.com.kh/zh">柬埔寨證券、銀行併購</a>
      `,
    },
    {
      id: 1002,
      title: "創投私募",
      icon: "http://cdn.asiamc.com.tw/KrYCnahJEPaCpFE4iRUBR7.jpg",
      linkListHtml: `
        <a rel="noreferrer" href="javascript:void(0)">安信國際資產</a><br/>
        <a rel="noreferrer" href="javascript:void(0)">誠信般若投資</a><br/>
        <a rel="noreferrer" href="javascript:void(0)">政大天使投資</a><br/>
        <a rel="noreferrer" href="javascript:void(0)">政大全球華商投資</a><br/>`,
    },
    {
      id: 1003,
      title: "金融科技",
      icon: "http://cdn.asiamc.com.tw/FwiCAEwhFN7bn8qv4LPms4.jpg",
      linkListHtml: `
        <a rel="noreferrer" href="javascript:void(0)">阿爾發</a>、
        <a target="_blank" rel="noreferrer" href="http://asiamc.area71.online/page?id=5">重量科技</a><br/>
        <a target="_blank" rel="noreferrer" href="http://asiamc.area71.online/page2?id=14">中華機器人理財協會</a><br/>`,
    },
    {
      id: 1004,
      title: "健康蔬食",
      icon: "http://cdn.asiamc.com.tw/MBYBPfzUaG2Xoat53UWAkY.jpg",
      linkListHtml: `
        <a target="_blank" rel="noreferrer" href="http://asiamc.area71.online/page2?id=9">啟心齋社會企業</a><br/>
        <a target="_blank" rel="noreferrer" href="http://asiamc.area71.online/page2?id=9">啟心齋愛心廚房</a><br/>
        <a target="_blank" rel="noreferrer" href="http://asiamc.area71.online/page2?id=9">啟心齋私人會所</a><br/>
        <a target="_blank" rel="noreferrer" href="https://www.facebook.com/profile.php?id=100063582173840">回家吃飯</a><br/>`,
    },
    {
      id: 1005,
      title: "國內外不動產/土地開發",
      icon: "http://cdn.asiamc.com.tw/AmorK2xDbYW7y7RYHNwdKn.jpg",
      linkListHtml: `
        <a target="_blank" rel="noreferrer" href="http://asiamc.area71.online/page2?id=47">熊本不動產</a><br/>
        <a rel="noreferrer" href="javascript:void(0)">金邊不動產</a><br/>
        <a rel="noreferrer" href="javascript:void(0)">西港經濟特區</a><br/>`,
    },
    {
      id: 1006,
      title: "健康科技",
      icon: "http://cdn.asiamc.com.tw/c6JxAdmTKY8vddUPemi5eo.jpg",
      linkListHtml: `
        <a target="_blank" rel="noreferrer" href="http://asiamc.area71.online/page?id=2">美思科技</a><br/>
        <a rel="noreferrer" href="javascript:void(0)">中華智能醫療科技推廣協會</a>`,
    },
    {
      id: 1007,
      title: "慈善公益",
      icon: "http://cdn.asiamc.com.tw/G8XUquHwELEvf3WmM7ihL9.jpg",
      linkListHtml: `
        <a target="_blank" rel="noreferrer" href="http://asiamc.area71.online/charity1?id=1">中華誠信慈善協會</a><br/>
        <a rel="noreferrer" href="javascript:void(0)">柬埔寨誠信慈善協會</a><br/>`,
    },
    {
      id: 1008,
      title: "社團活動",
      icon: "http://cdn.asiamc.com.tw/9yLqoxZByvEEG86keTFUjz.jpg",
      linkListHtml: `
        <a target="_blank" rel="noreferrer" href="http://asiamc.area71.online/page2?id=15">政大EMBA 2020全球華商班</a><br/>
        <a rel="noreferrer" href="javascript:void(0)">3461地區 臺中天元扶輪社</a><br/>
        <a rel="noreferrer" href="javascript:void(0)">臺大EMBA 財務金融組</a><br/>`,
    },
  ],
};

function About() {
  const [historyDataList, setHistoryDataList] = useState([]);
  const [groupDistributionDataList, setGroupDistributionDataList] = useState(null);

  useEffect(() => {
    axios
      .post("/api/website/getHistoryList")
      .then((response) => {
        setHistoryDataList(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching article content:", error);
      });
    setGroupDistributionDataList(MOCK_GROUP_DISTRIBUTION_DATA);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <section className="m-auto md-l:w-full">
          <ProfileArea />
        </section>
        <div className="mobile:py-16">
          <section className="group-distribution">
            <div className="wrapper">
              {groupDistributionDataList && <GroupDistribution data={groupDistributionDataList} />}
            </div>
          </section>
        </div>
        <section className="history-area pb-[200px]">
          <div className="wrapper">
            {historyDataList.length !== 0 && <HistoryArea dataList={historyDataList} />}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default About;
